import React, { useEffect, useState, useRef } from "react";
import "intl-tel-input/build/css/intlTelInput.css";
import IntlTelInput from "intl-tel-input/react";

const ContactInput = () => {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [fullPhone, setFullPhone] = useState("");

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setIsPhoneValid(false); // Reset on typing
  };

  const handleBlur = () => {
    // Safe check before using plugin
    
    if (
      typeof window !== "undefined" &&
      window.intlTelInputGlobals &&
      inputRef.current
    ) {
      alert('TTTT===');
      const iti = window.intlTelInputGlobals.getInstance(inputRef.current);
      alert(iti);
      if (iti && typeof iti.isValidNumber === "function") {
        const valid = iti.isValidNumber();
        const number = iti.getNumber();
        setIsPhoneValid(valid);
        setFullPhone(number);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = inputValue.trim();

    if (validateEmail(trimmed)) {
      alert(`✅ Valid email submitted: ${trimmed}`);
    } else if (isPhoneValid) {
      alert(`✅ Valid phone submitted: ${fullPhone}`);
    } else {
      alert("❌ Please enter a valid email or phone number.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <IntlTelInput
        inputRef={inputRef}
        fieldName="contact"
        value={inputValue}
        inputClassName="form-control"
        format
        autoHideDialCode={false}
        separateDialCode={true}
        preferredCountries={["in", "us"]}
        inputProps={{
          placeholder: "Enter email or mobile number",
          onChange: handleInputChange,
          onBlur: handleBlur,
        }}
      />

      <button type="submit" style={{ marginTop: "10px" }}>
        Submit
      </button>
    </form>
  );
};

export default ContactInput;